import dedent from 'dedent';
import { z } from 'zod';
import {
  coerceBoolean,
  coerceLiteralNumberRequired,
  coerceOptionalPositiveNumber,
  FIRST_VERSION_TIMESTAMP,
  zodTDateISODate
} from '~/lib/zod';
import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import * as v from 'valibot';
import form from '~/components/valibot/form';

export default createPerformableConfig(
  'twilight',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      photos: z.coerce.number().positive(),
      shoot_date: zodTDateISODate('Shoot Date is required'),
      notes: z.string().optional(),
      copyright: coerceBoolean().optional(),
      editing_credits: z.coerce.number().optional(),
    }),
  },
  {
    name: 'Twilight Photo Shoot (Separate Trip)',
    group: 'Listing',
    tenant: TenantId.BEYOND_RE_MARKETING,
    thumbnail: 'tenant/bre/twilight/thumbnail.jpg',
    images: [],
    submit: v.object({
      editing_credits: v.pipe(form.number(), v.minValue(0))
    }),
    short: dedent`
      Choose this option when you want the property photographed during \
      daylight hours and only want us to return to shoot the front and back of \
      the property at twilight.
    `,
  },
);
